var ResponsiveChecker = [],
  formCheckerObj = {},
  formCheckerElm;

//In Content Ebook Form
var contentResponsive = document.querySelectorAll(
  ".in-content-responsive-checker"
);
for (var i = 0; i < contentResponsive.length; i++) {
  formCheckerObj = {};
  formCheckerObj.formObj = contentResponsive[i];
  formCheckerObj.index = i;
  formCheckerObj.uniqueID = bsLib.uniqueID();

  formCheckerObj.formname = formCheckerObj.formObj.dataset.formname;
  formCheckerObj.urlField = formCheckerObj.formObj.querySelector(
    '[name="url"]'
  );

  ResponsiveChecker[i] = formCheckerObj;
}

var responsiveForm = (function(ResponsiveChecker) {
  return {
    setScope: setScope,
    init: init,
    resetForm: resetForm,
    validateFields: _validateFields
  };

  var formCheckerObj = {},
    uniqueID,
    index;

  function setScope(scope) {
    formCheckerObj = {};
    index = getFormIndex(scope);
    formCheckerObj = ResponsiveChecker[index];
    uniqueID = formCheckerObj.uniqueID;
  }

  function init() {
    //Form success and redirect
    _logFormSubmit("OnFormSuccess");

    //Success to redirect to responsive page
    window.location =
      bsLib.railsHost() + "/responsive?url=" + formCheckerObj.urlField.value;
  }

  function _validateFields() {
    var formValid = true,
      urlError = document.getElementById("url-error" + uniqueID),
      urlValidation = validURL(formCheckerObj.urlField.value);

    //Remove all errors
    removeAllError();

    if (formCheckerObj.urlField.value == "" || urlValidation.isInvalid) {
      formValid = _showError(
        formCheckerObj.urlField,
        urlError,
        "url-error" + uniqueID,
        urlValidation.errorMessage
      );
    }

    return formValid;
  }

  function validURL(str) {
    var pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return {
      isInvalid: !pattern.test(str),
      errorMessage: "Invalid URL"
    };
  }

  function _showError(fieldName, fieldError, errorName, errorMessage) {
    inlineError.showError(fieldName, fieldError, errorName, errorMessage);

    //Invalid Error Amplitude events
    WebEventTracker.logEvent("", "OnFormInvalidError", {
      formname: formCheckerObj.formname,
      field: fieldName.getAttribute("name"),
      message: errorMessage
    });

    return false;
  }

  function removeAllError() {
    //Remove all error element
    var errorMsg = formCheckerObj.formObj.querySelectorAll(".error-message");
    for (var i = 0; i < errorMsg.length; i++) {
      errorMsg[i].remove();
    }
    //remove error border class
    var errorMsg = formCheckerObj.formObj.parentElement.querySelectorAll(
      ".error-border"
    );
    for (var i = 0; i < errorMsg.length; i++) {
      errorMsg[i].classList.remove("error-border");
    }
  }

  //Get form index
  function getFormIndex(formObj) {
    var index;
    for (var i = 0; i < ResponsiveChecker.length; i++) {
      if (ResponsiveChecker[i].formObj == formObj) {
        index = ResponsiveChecker[i].index;
      }
    }

    return index;
  }

  function resetForm() {
    formCheckerObj.formObj[0].reset(); //Reset form
  }

  function _logFormSubmit(status) {
    //Send to webtracker
    WebEventTracker.logEvent("", status, {
      formname: formCheckerObj.formname
    });

    //GA call
    if (typeof ga !== "undefined") {
      ga("browserstack.send", "event", {
        eventCategory: "Responsive Checker",
        eventAction: "Submit",
        eventLabel: "Submit"
      });
    }
  }
})(ResponsiveChecker);

//In Content Responsive Checker Form
for (var i = 0; i < ResponsiveChecker.length; i++) {
  formCheckerElm = ResponsiveChecker[i];

  //Interacted with fields
  formCheckerElm.urlField.addEventListener("blur", function(e) {
    WebEventTracker.logEvent("", "InteractedWithAssetProperty", {
      formname: formCheckerElm.formname,
      field: "url"
    });
  });

  //Submit Contact Form
  formCheckerElm.formObj.addEventListener("submit", function(e) {
    e.preventDefault();
    //Interacted With Form
    WebEventTracker.logEvent("", "InteractedWithAssetProperty", {
      formname: formCheckerElm.formname,
      field: "Submit"
    });

    responsiveForm.setScope(this);

    if (!responsiveForm.validateFields()) {
      return false;
    }

    responsiveForm.init();
    return false;
  });
}
